module.exports = __webpack_public_path__ + "static/img/areaA_1.a079056.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA_1.png
// module id = 1064
// module chunks = 1